import { NoteAttrs, NoteNode } from './const';
const DEFAULT_TITLE_PLACEHOLDER = 'Note';
const DEFAULT_CONTENT_PLACEHOLDER = 'Note content';
export const getSpec = (opts, placeholder) => {
    var _a, _b, _c;
    return ({
        [NoteNode.Note]: {
            attrs: {
                [NoteAttrs.Class]: { default: 'yfm-note yfm-accent-info' },
                [NoteAttrs.Type]: { default: 'info' },
            },
            content: `${NoteNode.NoteTitle} ${NoteNode.NoteContent}`,
            group: 'block yfm-note',
            parseDOM: [
                {
                    tag: 'div.yfm-note',
                    priority: 100,
                    getAttrs: (node) => ({
                        [NoteAttrs.Class]: node.getAttribute(NoteAttrs.Class) || '',
                        [NoteAttrs.Type]: node.getAttribute(NoteAttrs.Type) || 'info',
                    }),
                },
            ],
            toDOM(node) {
                return ['div', node.attrs, 0];
            },
            selectable: true,
            allowSelection: true,
            complex: 'root',
        },
        [NoteNode.NoteTitle]: {
            content: 'inline*',
            group: 'block yfm-note',
            parseDOM: [
                {
                    tag: 'p.yfm-note-title',
                    priority: 100,
                },
            ],
            toDOM() {
                return ['p', { class: 'yfm-note-title' }, 0];
            },
            selectable: false,
            allowSelection: false,
            placeholder: {
                content: (_b = (_a = placeholder === null || placeholder === void 0 ? void 0 : placeholder[NoteNode.NoteTitle]) !== null && _a !== void 0 ? _a : opts === null || opts === void 0 ? void 0 : opts.yfmNoteTitlePlaceholder) !== null && _b !== void 0 ? _b : DEFAULT_TITLE_PLACEHOLDER,
                alwaysVisible: true,
            },
            complex: 'leaf',
        },
        [NoteNode.NoteContent]: {
            content: '(block | paragraph)+',
            group: 'block yfm-note',
            parseDOM: [
                {
                    tag: 'div.yfm-note-content',
                    priority: 100,
                },
            ],
            toDOM() {
                return ['div', { class: 'yfm-note-content' }, 0];
            },
            selectable: false,
            allowSelection: false,
            placeholder: {
                content: (_c = placeholder === null || placeholder === void 0 ? void 0 : placeholder[NoteNode.NoteContent]) !== null && _c !== void 0 ? _c : DEFAULT_CONTENT_PLACEHOLDER,
                alwaysVisible: true,
            },
            complex: 'leaf',
        },
    });
};
